import React from 'react';

import {
    Box
} from '@mui/material';

import SectionView from '../../components/home/SectionView';
import CarouselView from '../../components/home/CarouselView';

export default function CarouselSection(props){
    return (
        <Box sx={{width:'100%'}}>
            <SectionView>
                <CarouselView />
            </SectionView>
        </Box>
    )
}